<template>
  <div class="page_title">
    <div class="align py-3 px-4">
      <h1 class="px-1">
        <i class="fa-regular fa-chart-simple icon"></i>
        <span>Relatório de páginas</span>
      </h1>
    </div>
  </div>


  <div class="align p-4 space_title">
    <div class="card">
      <div class="p-4" id="table_filter">
        <div class="row">
          <div class="col-12 col-md-8 mb-2 mb-md-0">
            <InputText placeholder="Buscar" v-model="filter.search" />
          </div>
          <div class="col-12 col-md-4">
            <InputDatePicker placeholder="Data" v-model="filter.date" range />
          </div>
        </div>
      </div>

      <div class="table_container">
      <table>
        <thead>
          <tr>
            <th>Nome</th>
            <th>Visitas</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(page, key) in pages.data" :key="key">
            <td>
              {{ page.name }}
            </td>
            <td>
              {{ $numberFormat(page.views) }}
            </td>
            <td class="actions">
              <router-link :to="{ name: 'reportPage', params: { id: page.id }, query: { page: 1, date_start: dateStart, date_end: dateEnd }}">
                  <button class="btn btn-secondary" type="button">
                    <i class="fa-regular fa-chart-simple"></i>
                  </button>
                </router-link>
            </td>
          </tr>
          <tr class="no_result" v-if="!pages.data || (pages.data && !pages.data.length)">
            <td colspan="10">
              Nenhum resultado encontrado
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    </div>


    <ListPagination class="mt-4" :links="pages.meta.links" />
  </div>
</template>
  
<script setup>
import { computed, onBeforeMount, watch } from 'vue';
import { useReportStore } from '@/stores/ReportStore'
import { storeToRefs } from 'pinia';
import ListPagination from '@/components/ListPagination.vue'
import { inject } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import InputText from '@/components/InputText.vue'
import InputDatePicker from '@/components/InputDatePicker.vue'
import moment from 'moment';

const loader = inject('$loader');

const router = useRouter();
const route = useRoute();
const reportStore = useReportStore();
const { filter, pages } = storeToRefs(reportStore);

onBeforeMount(() => {
  reportStore.pages = {
      data: {},
      meta: {},
  };

  filter.value.search = null;

  if (route.query.search) {
    filter.value.search = route.query.search;
  }

  if (route.query.date_start) {
    filter.value.date = [route.query.date_start, route.query.date_end];
  }else {
    filter.value.date = [moment().utcOffset(-3).format('YYYY-MM-DD'), moment().utcOffset(-3).format('YYYY-MM-DD')];
  }

  loadPages();
});

const dateStart = computed({
  get: () => filter.value.date[0],
});

const dateEnd = computed({
  get: () => filter.value.date[1],
});

watch(() => route.query.page, (newPage, oldPage) => {
  if (newPage !== oldPage) {
    window.scrollTo(0, 0);
    loadPages();
  }
});

watch(() => filter.value.search, debounce(() => {
  const new_query = { ...route.query, page: 1, search: filter.value.search };
  router.push({ query: new_query }).then(() => {
    loadPages();
  });
}, 500));

watch(() => filter.value.date, debounce(() => {
  const new_query = { ...route.query, page: 1, date_start: dateStart.value, date_end: dateEnd.value };
  router.push({ query: new_query }).then(() => {
    loadPages();
  });
}, 500));

function debounce(func, wait) {
  let timeout;
  return function (...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}
 
async function loadPages() {
  loader.show();

  let params = {
    page: parseInt(route.query.page),
    search: filter.value.search,
    date_start: dateStart.value,
    date_end: dateEnd.value
  }

  await reportStore.getPages(params);
  loader.hide();
}
</script>